exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".title-wrap .title[data-v-b1160eb8]{position:relative;margin-top:1.6rem;width:100%;font-size:24px;font-family:'RobotoMedium';font-weight:800;color:#171717;line-height:.58rem;height:.58rem}\n", ""]);

